import React, { useCallback, useRef, useState } from "react";
import { connect } from "react-redux";
import "../../../../../om/css/salesorder.css";
import { GridLayout } from "../../../../../common/GridLayout";
import {
    Column,
    DataGrid,
    GroupPanel,
    Grouping,
    FilterRow,
    FilterPanel,
    HeaderFilter,
    SearchPanel,
    Sorting,
    Paging,
    Selection,
    Toolbar,
    Item,
    Export,
    Pager,
    ColumnChooser,
    ColumnChooserSearch,
    StateStoring,
} from "devextreme-react/data-grid";
import GridLayoutManager from "../../../../../gridLayoutCustomization/GridLayoutManager";

const ItemResult = (props) => {
    const dataGrid = useRef(null);
    var accessToken = props.oidc.user.access_token;
    const allowedPageSizes = [10, 20, 100, 500, 1000, "all"];
    const gridKey = "8b1e6d2a-4c3f-49a7-b6d1-2e7f0a9c1234";
    const [currentLayout, setCurrentLayout] = useState("Default");
    const saveState = useCallback((state) => { GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state, currentLayout); }, [gridKey, currentLayout]);
    const loadState = useCallback(() => { return GridLayout.sendStorageRequest(gridKey, "GET", accessToken, null, currentLayout); }, [currentLayout]);

    const onSelectionChanged = ({ selectedRowsData }) => {
        const selectedRowData = selectedRowsData[0];
        if (props.onItemSelected) {
            props.onItemSelected(selectedRowData);
        }
    };

    return (
        <div style={{ height: '100%' }}>
            <DataGrid
                onExporting={(e) => {
                    if (window.handleDevExtremeDataGridExport) {
                        window.handleDevExtremeDataGridExport(e);
                    }
                }}
                ref={dataGrid}
                height="100%"
                dataSource={props.data}
                allowColumnReordering={true}
                allowColumnResizing={true}
                showBorders={true}
                hoverStateEnabled={true}
                className="SearchOrderSalesResultOpenState"
                remoteOperations={true}
                searchEnabled={true}
                columnAutoWidth={true}
                onSelectionChanged={onSelectionChanged}
            >
                <ColumnChooser
                    enabled={true}
                    title="Choose Column"
                    width={290}
                    height={290}
                    sortOrder="asc"
                >
                    <ColumnChooserSearch
                        enabled={true}
                        editorOptions={{ placeholder: 'Search column' }} />
                </ColumnChooser>
                <Export enabled={true} allowExportSelectedData={true} />
                <Selection mode="single" />
                <Sorting visible={true} mode="multiple" />
                <Paging defaultPageSize={10} />
                <Pager
                    visible={true}
                    showPageSizeSelector={true}
                    allowedPageSizes={allowedPageSizes}
                    showNavigationButtons={true}
                />
                <FilterRow visible={true} />
                <FilterPanel visible={true} />
                <HeaderFilter visible={true} />
                <SearchPanel visible={true} width={240} placeholder="Search..." />
                <GroupPanel visible={true} />
                <Grouping autoExpandAll={false} />
                <StateStoring
                    enabled={true}
                    type="custom"
                    customLoad={loadState}
                    storageKey={gridKey}
                    customSave={saveState}
                />
                {/* Default-visible columns (match the legacy main grid) */}
                <Column dataField="CustomerIdentity" caption="Customer" />
                <Column dataField="CustomerName" caption="Customer Name" />
                <Column dataField="ItemCode" caption="Item" />
                <Column dataField="Description1" caption="Item Description - 1" />
                <Column dataField="ClassCode" caption="Class" />
                <Column dataField="SubClassCode" caption="Sub Class" />
                <Column dataField="NetAvailable" caption="Net Available" />
                {/* Available via the column chooser (hidden by default) */}
                <Column dataField="Address1" caption="Address - 1" visible={false} />
                <Column dataField="Address2" caption="Address - 2" visible={false} />
                <Column dataField="Available" caption="Available" visible={false} />
                <Column dataField="DateAvailable" caption="Available Date" dataType="date" format="MM/dd/yyyy" visible={false} />
                <Column dataField="InBackOrder" caption="BO-Receiving" visible={false} />
                <Column dataField="OutBackOrder" caption="BO-Shipping" visible={false} />
                <Column dataField="City" caption="City" visible={false} />
                <Column dataField="UserDefinedCode1" caption="Code 1" visible={false} />
                <Column dataField="UserDefinedCode2" caption="Code 2" visible={false} />
                <Column dataField="UserDefinedCode3" caption="Code 3" visible={false} />
                <Column dataField="UserDefinedCode4" caption="Code 4" visible={false} />
                <Column dataField="UserDefinedCode5" caption="Code 5" visible={false} />
                <Column dataField="UserDefinedCode6" caption="Code 6" visible={false} />
                <Column dataField="UserDefinedCode7" caption="Code 7" visible={false} />
                <Column dataField="UserDefinedCode8" caption="Code 8" visible={false} />
                <Column dataField="UserDefinedCode9" caption="Code 9" visible={false} />
                <Column dataField="UserDefinedCode10" caption="Code 10" visible={false} />
                <Column dataField="CreationUserId" caption="Created By" visible={false} />
                <Column dataField="CreationDateTime" caption="Creation Date" dataType="date" format="MM/dd/yyyy" visible={false} />
                <Column dataField="UserDefinedDate1" caption="Date 1" dataType="date" format="MM/dd/yyyy" visible={false} />
                <Column dataField="UserDefinedDate2" caption="Date 2" dataType="date" format="MM/dd/yyyy" visible={false} />
                <Column dataField="UserDefinedDate3" caption="Date 3" dataType="date" format="MM/dd/yyyy" visible={false} />
                <Column dataField="UserDefinedDate4" caption="Date 4" dataType="date" format="MM/dd/yyyy" visible={false} />
                <Column dataField="UserDefinedDate5" caption="Date 5" dataType="date" format="MM/dd/yyyy" visible={false} />
                <Column dataField="UserDefinedDate6" caption="Date 6" dataType="date" format="MM/dd/yyyy" visible={false} />
                <Column dataField="UserDefinedDate7" caption="Date 7" dataType="date" format="MM/dd/yyyy" visible={false} />
                <Column dataField="UserDefinedDate8" caption="Date 8" dataType="date" format="MM/dd/yyyy" visible={false} />
                <Column dataField="UserDefinedDate9" caption="Date 9" dataType="date" format="MM/dd/yyyy" visible={false} />
                <Column dataField="UserDefinedDate10" caption="Date 10" dataType="date" format="MM/dd/yyyy" visible={false} />
                <Column dataField="DateExpiration" caption="Expiration" dataType="date" format="MM/dd/yyyy" visible={false} />
                <Column dataField="InFuture" caption="Future Rec" visible={false} />
                <Column dataField="OutFuture" caption="Future Ship" visible={false} />
                <Column dataField="HazardousFlag" caption="Hazardous Flag" visible={false} />
                <Column dataField="InReceiving" caption="In-Receiving" visible={false} />
                <Column dataField="OutShipped" caption="In-Shipping" visible={false} />
                <Column dataField="DateIntroduced" caption="Introduced Date" dataType="date" format="MM/dd/yyyy" visible={false} />
                <Column dataField="InventoryUnitUom" caption="Inventory UOM" visible={false} />
                <Column dataField="Description2" caption="Item Description - 2" visible={false} />
                <Column dataField="LastUpdateDateTime" caption="Last Updated" dataType="date" format="MM/dd/yyyy" visible={false} />
                <Column dataField="LastUpdateUserId" caption="Last Updated By" visible={false} />
                <Column dataField="OnHand" caption="On Hand" visible={false} />
                <Column dataField="ReceiptPackSize" caption="Pack & Size - Receipts" visible={false} />
                <Column dataField="ShipmentPackSize" caption="Pack & Size - Shipments" visible={false} />
                <Column dataField="InOrdered" caption="Pending Rec" visible={false} />
                <Column dataField="OutOrdered" caption="Pending Ship" visible={false} />
                <Column dataField="UserDefinedQuantity1" caption="Quantity 1" visible={false} />
                <Column dataField="UserDefinedQuantity2" caption="Quantity 2" visible={false} />
                <Column dataField="UserDefinedQuantity3" caption="Quantity 3" visible={false} />
                <Column dataField="UserDefinedQuantity4" caption="Quantity 4" visible={false} />
                <Column dataField="UserDefinedQuantity5" caption="Quantity 5" visible={false} />
                <Column dataField="UserDefinedQuantity6" caption="Quantity 6" visible={false} />
                <Column dataField="UserDefinedQuantity7" caption="Quantity 7" visible={false} />
                <Column dataField="UserDefinedQuantity8" caption="Quantity 8" visible={false} />
                <Column dataField="UserDefinedQuantity9" caption="Quantity 9" visible={false} />
                <Column dataField="UserDefinedQuantity10" caption="Quantity 10" visible={false} />
                <Column dataField="Record" caption="Record #" visible={false} />
                <Column dataField="UserDefinedReference1" caption="Reference 1" visible={false} />
                <Column dataField="UserDefinedReference2" caption="Reference 2" visible={false} />
                <Column dataField="UserDefinedReference3" caption="Reference 3" visible={false} />
                <Column dataField="UserDefinedReference4" caption="Reference 4" visible={false} />
                <Column dataField="UserDefinedReference5" caption="Reference 5" visible={false} />
                <Column dataField="UserDefinedReference6" caption="Reference 6" visible={false} />
                <Column dataField="UserDefinedReference7" caption="Reference 7" visible={false} />
                <Column dataField="UserDefinedReference8" caption="Reference 8" visible={false} />
                <Column dataField="UserDefinedReference9" caption="Reference 9" visible={false} />
                <Column dataField="UserDefinedReference10" caption="Reference 10" visible={false} />
                <Column dataField="StackHeight" caption="Stack Height" visible={false} />
                <Column dataField="State" caption="State" visible={false} />
                <Toolbar>
                    <Item location="after">
                        <GridLayoutManager gridKey={gridKey} dataGrid={dataGrid} setCurrentLayout={setCurrentLayout} />
                    </Item>
                    <Item name="exportButton" />
                    <Item name="columnChooserButton" />
                </Toolbar>
            </DataGrid>
        </div>
    );
};
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(ItemResult);
